module.exports = __webpack_public_path__ + "assets/scene-pic1.png";